// Shows a "session terminated" popup when the auth session/cookie has expired
// (server returns 401). On OK, the user is logged out via oauth2-proxy and sent
// back to the login page.

let modalShown = false;

const logoutAndRedirect = () => {
  try {
    sessionStorage.clear();
    localStorage.clear();
  } catch (e) {
    // ignore storage access errors
  }
  // oauth2-proxy clears the session cookie, then redirects back to the login page
  window.location.href = '/oauth2/sign_out?rd=/login';
};

// Modal text per language. Mirrors the app's langOpt values
// ('Japanese' | 'English' | 'Indonesian'), defaulting to Japanese.
const SESSION_EXPIRED_TEXT = {
  Japanese: { title: 'セッションが終了しました', message: '再度ログインしてください', button: 'サインイン' },
  English: { title: 'Session terminated', message: 'Please login again.', button: 'Sign in' },
  Indonesian: { title: 'Sesi berakhir', message: 'Silakan masuk kembali.', button: 'Masuk' },
};

export const handleSessionExpired = () => {
  if (modalShown) return;
  modalShown = true;

  // Read the language the user picked (persisted in sessionStorage by App.js).
  const lang = sessionStorage.getItem('langOpt') || 'Japanese';
  const text = SESSION_EXPIRED_TEXT[lang] || SESSION_EXPIRED_TEXT.Japanese;

  const overlay = document.createElement('div');
  overlay.id = 'session-expired-overlay';
  overlay.style.cssText = [
    'position:fixed',
    'inset:0',
    'z-index:2147483647',
    'display:flex',
    'align-items:center',
    'justify-content:center',
    'background:rgba(0,0,0,0.5)',
  ].join(';');

  const box = document.createElement('div');
  box.style.cssText = [
    'background:#ffffff',
    'border-radius:12px',
    'padding:28px 32px',
    'max-width:380px',
    'width:90%',
    'text-align:center',
    'font-family:Arial, Helvetica, sans-serif',
    'box-shadow:0 10px 40px rgba(0,0,0,0.25)',
  ].join(';');

  const title = document.createElement('h2');
  title.textContent = text.title;
  title.style.cssText = 'margin:0 0 10px;font-size:20px;color:#1a1a1a;';

  const message = document.createElement('p');
  message.textContent = text.message;
  message.style.cssText = 'margin:0 0 22px;font-size:15px;color:#555555;';

  const okButton = document.createElement('button');
  okButton.textContent = text.button;
  okButton.style.cssText = [
    'background:#e2001a',
    'color:#ffffff',
    'border:none',
    'border-radius:8px',
    'padding:10px 28px',
    'font-size:15px',
    'cursor:pointer',
  ].join(';');
  okButton.onclick = logoutAndRedirect;

  box.appendChild(title);
  box.appendChild(message);
  box.appendChild(okButton);
  overlay.appendChild(box);
  document.body.appendChild(overlay);
};
